import { type SVGProps } from "react";

export type IconProps = {
  fontSize?: string | number;
  color?: string;
  id?: string;
  className?: string;
} & SVGProps<SVGSVGElement>;

const CheckIconSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.4146 17.6538L5.08008 12.3193L6.14908 11.2501L10.4146 15.5156L19.5801 6.3501L20.6491 7.41935L10.4146 17.6538Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckIcon = ({ id, className = "", ...props }: IconProps) => {
  return <CheckIconSvg {...props} id={id} className={className} aria-hidden />;
};
CheckIcon.displayName = "CheckIcon";
